import React from 'react'
import '../Portfolio/Underdev.css'
import { BiTime } from 'react-icons/bi'
import { GrFormClose } from 'react-icons/gr'

const Underdev = ({handleClose}) => {
  return (
    <div className="underdev">
        <GrFormClose className='close' onClick={handleClose} />
      <div className="boxe">
        <BiTime className='progress'/>
      <p className="para">
            Project
        </p>
        <p className="para">
            Under Development
        </p>
      </div>
    </div>
  )
}

export default Underdev
